module.exports = __webpack_public_path__ + "img/Cadiz.1ef6b6e4.png";